import React from 'react';
import { Modal } from './Modal';
import { Mail, MessageCircle, Shield, Lock, FileText, Clock } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'support' | 'contact' | 'terms' | 'privacy';
}
export function LegalModal({
  isOpen,
  onClose,
  type
}: LegalModalProps) {
  const content = {
    support: {
      title: 'Soporte',
      icon: <MessageCircle className="w-8 h-8 text-primary" data-id="element-157" />,
      body: <div className="space-y-6" data-id="element-158">
          <div className="flex items-start gap-4" data-id="element-159">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-160">
              <Clock className="w-6 h-6 text-primary" data-id="element-161" />
            </div>
            <div data-id="element-162">
              <h3 className="text-xl font-semibold text-text-main mb-2" data-id="element-163">
                Tiempo de Respuesta
              </h3>
              <p className="text-text-muted leading-relaxed" data-id="element-164">
                Respondemos todas las consultas en un plazo de 24-48 horas
                hábiles. Tu tranquilidad es importante para nosotros.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-165">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-166">
              <Mail className="w-6 h-6 text-primary" data-id="element-167" />
            </div>
            <div data-id="element-168">
              <h3 className="text-xl font-semibold text-text-main mb-2" data-id="element-169">
                Contacto Directo
              </h3>
              <p className="text-text-muted leading-relaxed mb-2" data-id="element-170">
                ¿Tienes alguna pregunta sobre el ebook o necesitas ayuda con tu
                descarga?
              </p>
              <a href="mailto:contactomikioscodigital@gmail.com" className="text-primary hover:text-primary-dark font-medium transition-colors" data-id="element-171">
                contactomikioscodigital@gmail.com
              </a>
            </div>
          </div>

          <div className="bg-amber-50 rounded-2xl p-6" data-id="element-172">
            <h3 className="text-lg font-semibold text-text-main mb-3" data-id="element-173">
              Preguntas Frecuentes
            </h3>
            <ul className="space-y-3 text-text-muted" data-id="element-174">
              <li className="flex items-start gap-2" data-id="element-175">
                <span className="text-primary mt-1" data-id="element-176">•</span>
                <span data-id="element-177">
                  ¿No recibiste el email de descarga? Revisa tu carpeta de spam
                  o escríbenos.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-178">
                <span className="text-primary mt-1" data-id="element-179">•</span>
                <span data-id="element-180">
                  ¿Problemas técnicos con el PDF? Te enviamos una copia
                  alternativa.
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-181">
                <span className="text-primary mt-1" data-id="element-182">•</span>
                <span data-id="element-183">
                  ¿Dudas sobre el contenido? Estamos aquí para guiarte.
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-r from-primary/5 to-transparent rounded-2xl p-6 border-l-4 border-primary" data-id="element-184">
            <p className="text-text-main leading-relaxed italic" data-id="element-185">
              Nuestro compromiso es que te sientas acompañada en cada paso de tu
              camino hacia el autocuidado.
            </p>
          </div>
        </div>
    },
    contact: {
      title: 'Contacto',
      icon: <Mail className="w-8 h-8 text-primary" data-id="element-186" />,
      body: <div className="space-y-6" data-id="element-187">
          <div className="text-center mb-8" data-id="element-188">
            <p className="text-xl text-text-main leading-relaxed" data-id="element-189">
              Nos encantaría saber de ti. Ya sea una pregunta, sugerencia o
              simplemente quieres compartir tu experiencia.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-6 border border-gray-200" data-id="element-190">
            <h3 className="text-lg font-semibold text-text-main mb-4" data-id="element-191">
              Email Principal
            </h3>
            <a href="mailto:contactomikioscodigital@gmail.com" className="text-2xl text-primary hover:text-primary-dark font-medium transition-colors" data-id="element-192">
              contactomikioscodigital@gmail.com
            </a>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-193">
            <div className="bg-amber-50 rounded-2xl p-6" data-id="element-194">
              <h4 className="font-semibold text-text-main mb-2" data-id="element-195">
                Consultas Generales
              </h4>
              <p className="text-text-muted text-sm" data-id="element-196">
                Preguntas sobre el programa, contenido o metodología
              </p>
            </div>
            <div className="bg-stone-50 rounded-2xl p-6" data-id="element-197">
              <h4 className="font-semibold text-text-main mb-2" data-id="element-198">
                Soporte Técnico
              </h4>
              <p className="text-text-muted text-sm" data-id="element-199">
                Ayuda con descargas, acceso o problemas técnicos
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-2xl p-8 text-center" data-id="element-200">
            <h3 className="text-2xl font-serif mb-3" data-id="element-201">
              Colaboraciones y Prensa
            </h3>
            <p className="mb-4 opacity-90" data-id="element-202">
              ¿Interesada en colaborar o compartir nuestra misión?
            </p>
            <a href="mailto:colaboraciones@autocuidado5min.com" className="text-white hover:text-amber-100 font-medium transition-colors underline" data-id="element-203">
              colaboraciones@autocuidado5min.com
            </a>
          </div>

          <div className="text-center text-text-muted text-sm" data-id="element-204">
            <p data-id="element-205">Tiempo de respuesta: 24-48 horas hábiles</p>
          </div>
        </div>
    },
    terms: {
      title: 'Términos y Condiciones',
      icon: <FileText className="w-8 h-8 text-primary" data-id="element-206" />,
      body: <div className="space-y-6 text-text-muted" data-id="element-207">
          <div className="bg-amber-50 rounded-2xl p-6" data-id="element-208">
            <p className="text-text-main leading-relaxed" data-id="element-209">
              Al adquirir "Autocuidado de 5 Minutos para Mamás Agotadas",
              aceptas los siguientes términos de uso y servicio.
            </p>
          </div>

          <div data-id="element-210">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-211">
              1. Licencia de Uso
            </h3>
            <p className="leading-relaxed mb-2" data-id="element-212">
              Al comprar este ebook, obtienes una licencia personal e
              intransferible para:
            </p>
            <ul className="space-y-2 ml-4" data-id="element-213">
              <li className="flex items-start gap-2" data-id="element-214">
                <span className="text-primary mt-1" data-id="element-215">•</span>
                <span data-id="element-216">
                  Descargar y leer el contenido en tus dispositivos personales
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-217">
                <span className="text-primary mt-1" data-id="element-218">•</span>
                <span data-id="element-219">Imprimir una copia para uso personal</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-220">
                <span className="text-primary mt-1" data-id="element-221">•</span>
                <span data-id="element-222">
                  Acceder a todos los bonos y materiales complementarios
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-223">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-224">
              2. Restricciones
            </h3>
            <p className="leading-relaxed mb-2" data-id="element-225">No está permitido:</p>
            <ul className="space-y-2 ml-4" data-id="element-226">
              <li className="flex items-start gap-2" data-id="element-227">
                <span className="text-primary mt-1" data-id="element-228">•</span>
                <span data-id="element-229">Compartir, revender o distribuir el contenido</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-230">
                <span className="text-primary mt-1" data-id="element-231">•</span>
                <span data-id="element-232">Reproducir o publicar el material sin autorización</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-233">
                <span className="text-primary mt-1" data-id="element-234">•</span>
                <span data-id="element-235">Modificar o crear obras derivadas del contenido</span>
              </li>
            </ul>
          </div>

          <div data-id="element-236">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-237">
              3. Garantía de Satisfacción
            </h3>
            <p className="leading-relaxed" data-id="element-238">
              Ofrecemos una garantía de devolución de 30 días sin preguntas. Si
              el programa no cumple tus expectativas, contáctanos para un
              reembolso completo.
            </p>
          </div>

          <div data-id="element-239">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-240">
              4. Descargo de Responsabilidad
            </h3>
            <p className="leading-relaxed" data-id="element-241">
              Este ebook ofrece técnicas de autocuidado y bienestar. No
              sustituye el consejo médico o psicológico profesional. Si
              experimentas problemas de salud mental, consulta con un
              profesional calificado.
            </p>
          </div>

          <div data-id="element-242">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-243">
              5. Propiedad Intelectual
            </h3>
            <p className="leading-relaxed" data-id="element-244">
              Todo el contenido, incluyendo textos, imágenes y diseño, está
              protegido por derechos de autor. Todos los derechos reservados ©
              2024.
            </p>
          </div>

          <div className="bg-stone-50 rounded-2xl p-6 mt-8" data-id="element-245">
            <p className="text-sm text-text-muted" data-id="element-246">
              Última actualización: Diciembre 2024. Nos reservamos el derecho de
              actualizar estos términos. Los cambios se comunicarán por email.
            </p>
          </div>
        </div>
    },
    privacy: {
      title: 'Política de Privacidad',
      icon: <Lock className="w-8 h-8 text-primary" data-id="element-247" />,
      body: <div className="space-y-6 text-text-muted" data-id="element-248">
          <div className="bg-gradient-to-r from-primary/10 to-transparent rounded-2xl p-6 border-l-4 border-primary" data-id="element-249">
            <p className="text-text-main leading-relaxed font-medium" data-id="element-250">
              Tu privacidad es sagrada. Protegemos tus datos con el mismo
              cuidado que ponemos en nuestro contenido.
            </p>
          </div>

          <div data-id="element-251">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-252">
              1. Información que Recopilamos
            </h3>
            <p className="leading-relaxed mb-2" data-id="element-253">
              Al realizar una compra, recopilamos:
            </p>
            <ul className="space-y-2 ml-4" data-id="element-254">
              <li className="flex items-start gap-2" data-id="element-255">
                <span className="text-primary mt-1" data-id="element-256">•</span>
                <span data-id="element-257">
                  Nombre y dirección de email (para entrega del producto)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-258">
                <span className="text-primary mt-1" data-id="element-259">•</span>
                <span data-id="element-260">
                  Información de pago (procesada de forma segura por nuestro
                  proveedor)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-261">
                <span className="text-primary mt-1" data-id="element-262">•</span>
                <span data-id="element-263">Datos de navegación básicos (cookies analíticas)</span>
              </li>
            </ul>
          </div>

          <div data-id="element-264">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-265">
              2. Cómo Usamos tu Información
            </h3>
            <ul className="space-y-2 ml-4" data-id="element-266">
              <li className="flex items-start gap-2" data-id="element-267">
                <span className="text-primary mt-1" data-id="element-268">•</span>
                <span data-id="element-269">Entregar tu ebook y materiales bonos</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-270">
                <span className="text-primary mt-1" data-id="element-271">•</span>
                <span data-id="element-272">
                  Enviar actualizaciones y contenido relacionado (puedes
                  cancelar en cualquier momento)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-273">
                <span className="text-primary mt-1" data-id="element-274">•</span>
                <span data-id="element-275">Mejorar nuestros productos y servicios</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-276">
                <span className="text-primary mt-1" data-id="element-277">•</span>
                <span data-id="element-278">Procesar reembolsos si los solicitas</span>
              </li>
            </ul>
          </div>

          <div data-id="element-279">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-280">
              3. Protección de Datos
            </h3>
            <p className="leading-relaxed" data-id="element-281">
              Utilizamos encriptación SSL y almacenamiento seguro. No
              compartimos, vendemos ni alquilamos tu información personal a
              terceros. Los datos de pago son procesados por proveedores
              certificados (Stripe/PayPal) y nunca almacenamos información de
              tarjetas.
            </p>
          </div>

          <div data-id="element-282">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-283">
              4. Tus Derechos
            </h3>
            <p className="leading-relaxed mb-2" data-id="element-284">Tienes derecho a:</p>
            <ul className="space-y-2 ml-4" data-id="element-285">
              <li className="flex items-start gap-2" data-id="element-286">
                <span className="text-primary mt-1" data-id="element-287">•</span>
                <span data-id="element-288">Acceder a tus datos personales</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-289">
                <span className="text-primary mt-1" data-id="element-290">•</span>
                <span data-id="element-291">Solicitar corrección o eliminación de tus datos</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-292">
                <span className="text-primary mt-1" data-id="element-293">•</span>
                <span data-id="element-294">
                  Cancelar la suscripción a emails en cualquier momento
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-295">
                <span className="text-primary mt-1" data-id="element-296">•</span>
                <span data-id="element-297">Solicitar una copia de tu información</span>
              </li>
            </ul>
          </div>

          <div data-id="element-298">
            <h3 className="text-xl font-semibold text-text-main mb-3" data-id="element-299">
              5. Cookies
            </h3>
            <p className="leading-relaxed" data-id="element-300">
              Usamos cookies esenciales para el funcionamiento del sitio y
              cookies analíticas para entender cómo mejorarlo. No usamos cookies
              de publicidad de terceros.
            </p>
          </div>

          <div className="bg-amber-50 rounded-2xl p-6" data-id="element-301">
            <h3 className="text-lg font-semibold text-text-main mb-3" data-id="element-302">
              Contacto sobre Privacidad
            </h3>
            <p className="leading-relaxed mb-2" data-id="element-303">
              Para ejercer tus derechos o hacer consultas sobre privacidad:
            </p>
            <a href="mailto:contactomikioscodigital@gmail.com" className="text-primary hover:text-primary-dark font-medium transition-colors" data-id="element-304">
              contactomikioscodigital@gmail.com
            </a>
          </div>

          <div className="bg-stone-50 rounded-2xl p-6 mt-8" data-id="element-305">
            <p className="text-sm" data-id="element-306">
              Última actualización: Diciembre 2024. Esta política puede
              actualizarse periódicamente. Te notificaremos de cambios
              significativos por email.
            </p>
          </div>
        </div>
    }
  };
  const currentContent = content[type];
  return <Modal isOpen={isOpen} onClose={onClose} title={currentContent.title} data-id="element-307">
      <div className="mb-6 flex justify-center" data-id="element-308">{currentContent.icon}</div>
      {currentContent.body}
    </Modal>;
}